import { SuppliesPaymentTerms } from "@redotech/redo-fulfillment-common/supplies";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { FormSelectDropdown } from "@redotech/redo-web/select-dropdown";
import { FormSwitch } from "@redotech/redo-web/switch";
import { input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const showSuppliesStorefrontInput = input<boolean>();
export const showSuppliesStorefrontDefault = false;

// These map to settings.supplies (not settings.outboundLabels); the outbound
// label form reads/writes them separately in its value builder and save.
export const allowInventoryTriggeredReorderingInput = input<boolean>();
export const allowInventoryTriggeredReorderingDefault = false;

export const allowScheduledReorderingInput = input<boolean>();
export const allowScheduledReorderingDefault = false;

// Undefined = immediate (charge the chosen method at checkout).
export const paymentTermsInput = input<SuppliesPaymentTerms | undefined>();
export const paymentTermsDefault = undefined;

const PAYMENT_TERMS_LABEL: Record<SuppliesPaymentTerms, string> = {
  [SuppliesPaymentTerms.Net15]: "Net 15",
  [SuppliesPaymentTerms.Net30]: "Net 30",
};

export const SuppliesSettingsCard = memo(function SuppliesSettingsCard({
  input,
}: {
  input: OutboundLabelForm;
}) {
  return (
    <Card title="Supplies Settings" w="full">
      <Flex dir="column" gap="md">
        <FormSwitch
          input={input.inputs.showSuppliesStorefront}
          label="Show Supplies Storefront"
        />
        <FormSwitch
          input={input.inputs.allowInventoryTriggeredReordering}
          label="Allow inventory-triggered reordering"
        />
        <FormSwitch
          disabled
          disabledTooltip="Scheduled reordering isn't available yet"
          input={input.inputs.allowScheduledReordering}
          label="Allow scheduled reordering"
        />
        <FormSelectDropdown
          input={input.inputs.paymentTerms}
          label="Payment terms"
          options={[
            undefined,
            SuppliesPaymentTerms.Net15,
            SuppliesPaymentTerms.Net30,
          ]}
        >
          {(option) => (option ? PAYMENT_TERMS_LABEL[option] : "Immediate")}
        </FormSelectDropdown>
      </Flex>
    </Card>
  );
});
